export default __webpack_public_path__ + "static/media/central-bazar.1e34d7e8.mp4";